import { useCallback } from 'react';
import { useChatContext } from '../../../context';
import { useStateStore } from '../../../store';
export const useMessageReminder = (messageId) => {
    const { client } = useChatContext();
    const reminderSelector = useCallback((state) => ({
        reminder: state.reminders.get(messageId),
    }), [messageId]);
    const { reminder } = useStateStore(client.reminders.state, reminderSelector);
    return reminder;
};
